import React from 'react';
import {Map, Marker, Polyline} from "google-maps-react";

export default class RoutingMap extends React.PureComponent {

    decodePolyline = (encoded) => {

        // array that holds the points

        var points = []
        var index = 0, len = encoded.length;
        var lat = 0, lng = 0;
        while (index < len) {
            let b, shift = 0, result = 0;
            do {

                b = encoded.charAt(index++).charCodeAt(0) - 63;
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);


            let dlat = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
            lat += dlat;
            shift = 0;
            result = 0;
            do {
                b = encoded.charAt(index++).charCodeAt(0) - 63;
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);
            let dlng = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
            lng += dlng;

            points.push({lat: (lat / 1E5), lng: (lng / 1E5)})

        }
        return points
    }

    getAllPoints = () => {
        const {polylines, markers} = this.props;
        let allPoints = [];

        (polylines || []).flat().forEach(p => {
            this.decodePolyline(p).forEach(point => allPoints.push(point));
        });

        (markers || []).flat().forEach(m => {
            allPoints.push({lat: m.lat, lng: m.lng});
        });

        return allPoints;
    }

    getBounds = () => {
        if (!window.google || !window.google.maps) {
            console.warn('Google Maps API is not loaded yet');
            return null;
        }

        const points = this.getAllPoints();
        const bounds = new window.google.maps.LatLngBounds();

        if (points.length === 0) {
            bounds.extend({lat: 50.142002, lng: 8.6073363});
            bounds.extend({lat: 50.079344, lng: 8.779646});
        } else {
            points.forEach(p => bounds.extend(p));
        }

        return bounds;
    }

    zoomfactor = (minLngWest, maxLngEast) => {
        let globe_width = 256;
        let angel = maxLngEast - minLngWest;
        if (angel < 0) {
            angel += 360;
        }
        return Math.round(Math.log(960 * 360 / angel / globe_width) / Math.LN2) - 2;
    }

    render() {
        const {google, markers = [], polylines = [] } = this.props;

        const bounds = this.getBounds();
        if (!bounds) return null;

        return (
            <Map
                mapType={'roadmap'}
                google={google}
                containerStyle={{width: '100%', height: '500px', position: 'relative'}}
                bounds={bounds}
                zoom={this.zoomfactor(bounds.getSouthWest().lng(), bounds.getNorthEast().lng())}
                initialCenter={{
                    lat: bounds.getCenter()?.lat(),
                    lng: bounds.getCenter()?.lng()
                }}
            >
                {markers.flatMap((markerSet, index) =>
                    markerSet.map((marker, i) => (
                        <Marker
                            key={`route-${index}-marker-${i}`}
                            title={marker.title ?? ''}
                            position={{lat: marker.lat, lng: marker.lng}}
                            icon={`https://maps.google.com/mapfiles/ms/icons/${marker.color}-dot.png`}
                        />
                    ))
                )}

                {polylines.map((polylineSet, index) => {
                    return (polylineSet.polylines ?? []).map((polyline, i) => (
                        <Polyline
                            key={`route-${index}-line-${i}`}
                            path={this.decodePolyline(polyline)}
                            strokeWeight={3}
                            strokeColor={polylineSet.color}
                        />
                    )) }
                )}
            </Map>
        );
    }
}


RoutingMap.defaultProps = {};


